import { useState } from "react";
import MapContainer from "components/map/MapContainer";
import { GoogleMap } from "types/map";
import { LatLng } from "types/map";
import { mapEmbedCardMarkerNavigate } from "libraries/map";
import useMapShareTripParams from "hooks/maps/useMapShareTripParams";
import MapMarkersExperience from "components/map/MapMarkersExperience";

const MapEmbedPage = () => {
  useMapShareTripParams();

  const [map, setMap] = useState<GoogleMap | null>(null);
  const [defaultCenterGeo] = useState<LatLng>({ lat: 0, lng: 0 });
  const [defaultZoomLevel] = useState(3);

  return (
    <MapContainer
      map={map}
      boundaryWidth="100vw"
      boundaryHeight="100vh"
      onMapInitialized={setMap}
      center={defaultCenterGeo}
      zoom={defaultZoomLevel}
      disableDefaultUI
      zoomControl={false}
    >
      <>
        <MapMarkersExperience
          map={map}
          onCardClick={mapEmbedCardMarkerNavigate}
        />
      </>
    </MapContainer>
  );
};

export default MapEmbedPage;
